const article = {
    id: 'studio-floor-pages',
    title: 'Shipment, pack, and audit pages',
    summary: 'Sidebar pages for expected and received shipments, ready to pack, pending audit, audit approvals, audited outbound, and minibatch performance.',
    publishedAt: '2026-09-09',
    tags: ['shipments', 'audit'],
    sections: [
        {
            type: 'paragraph',
            text: 'Studio floor work that used to be spread across other screens now has its own sidebar pages. Open the one that matches the queue you are checking.',
        },
        { type: 'heading', text: 'Expected and received shipments' },
        {
            type: 'steps',
            items: [
                'Open Expected Shipments to see what is due, including draft and announced shipments.',
                'Open Received Shipments to see what arrived.',
                'On a received shipment, open the CMR column to view the CMR sheet image or link.',
            ],
        },
        { type: 'heading', text: 'Pack and outbound' },
        {
            type: 'steps',
            items: [
                'Open Ready To Pack for a client count of SKUs waiting to pack, split by age.',
                'Open Audited Outbound for boxes that are audited and waiting to leave, grouped by client and destination.',
            ],
        },
        { type: 'heading', text: 'Audit' },
        {
            type: 'steps',
            items: [
                'Open Pending Audit for boxes still in audit.',
                'Open Audit Approvals to review a box, see the scans, and approve or reject.',
            ],
        },
        { type: 'heading', text: 'Minibatching' },
        {
            type: 'steps',
            items: [
                'Open Minibatching Performance.',
                'Search and pick a shoot session.',
                'Switch between operator and other views for that session.',
            ],
        },
    ],
};

export default article;
